import { render } from "./BereidJeUitvaartVoor.vue?vue&type=template&id=68620753"
import script from "./BereidJeUitvaartVoor.vue?vue&type=script&lang=js"
export * from "./BereidJeUitvaartVoor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__